import { Select } from '@mobiscroll/react';
import './index.css';

export default Select;
